import type {
  CreateSafetyReportRequest,
  SafetyReportDto,
  UserBlockDto,
} from '@tracedocuments/types';

import { getApiErrorMessage } from './errors';
import { apiFetch } from './fetch';

async function readJson<T>(res: Response): Promise<T> {
  if (!res.ok) {
    const message = await getApiErrorMessage(res);
    throw new Error(message ?? `request failed (${res.status})`);
  }
  return (await res.json()) as T;
}

export async function fetchUserBlocks(): Promise<UserBlockDto[]> {
  const res = await apiFetch('/api/safety/blocks');
  return readJson<UserBlockDto[]>(res);
}

export async function blockUser(userId: string): Promise<UserBlockDto> {
  const res = await apiFetch('/api/safety/blocks', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ userId }),
  });
  return readJson<UserBlockDto>(res);
}

export async function unblockUser(blockedUserId: string): Promise<void> {
  const res = await apiFetch(`/api/safety/blocks/${blockedUserId}`, { method: 'DELETE' });
  if (!res.ok) {
    const message = await getApiErrorMessage(res);
    throw new Error(message ?? `unblock failed (${res.status})`);
  }
}

export async function createSafetyReport(
  request: CreateSafetyReportRequest,
): Promise<SafetyReportDto> {
  const res = await apiFetch('/api/safety/reports', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
  });
  return readJson<SafetyReportDto>(res);
}
